// Helper function to get auth token
export const getAuthToken = () => {
  try {
    const s = sessionStorage.getItem("authUser");
    if (s && JSON.parse(s)?.token) return JSON.parse(s).token;

    const l = localStorage.getItem("authUser");
    if (l && JSON.parse(l)?.token) return JSON.parse(l).token;
  } catch (e) {
    console.warn("Token parse error:", e);
  }

  return (
    sessionStorage.getItem("token") ||
    localStorage.getItem("token") ||
    null
  );
};

// API Base URL
const API_BASE = (process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_FLASK_API_URL || "").replace(/\/+$/, "");

// API fetch helper
export const fetchAPI = async (endpoint, options = {}) => {
  const token = getAuthToken();
  const response = await fetch(`${API_BASE}${endpoint}`, {
    ...options,
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
      ...options.headers,
    }
  });
  
  if (!response.ok) {
    throw new Error(`API Error: ${response.status}`);
  }
  
  return response.json();
};

// Flask API helper
export const getFlaskCredentials = () => ({
  apiUrl: localStorage.getItem("flaskApiUrl"),
  apiKey: localStorage.getItem("flaskApiKey")
});

export const fetchWithFlaskAuth = async (url) => {
  const { apiUrl, apiKey } = getFlaskCredentials();
  if (!apiUrl || !apiKey) {
    throw new Error("Flask API credentials not configured");
  }

  const headers = { 
    "Content-Type": "application/json",
    "X-API-Key": apiKey
  };

  const response = await fetch(`${apiUrl}${url}`, { headers });
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || "Request failed");
  }

  return data;
};